import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarSearch from "./SidebarSearch";
import SidebarNavItems from "./SidebarNavItems";

import { Store } from "../../../flux";
import nav_store from "../../../_stores/sidenav.store";

class MainSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: Store.getMenuState(),
      sidebarNavItems: [],
    };
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
    this.setState({ sidebarNavItems: nav_store.getState().sideNavItems });
    this.navUnsubscribe = nav_store.subscribe(() => {
      this.setState({ sidebarNavItems: nav_store.getState().sideNavItems });
    });
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
    this.navUnsubscribe();
  }

  async onChange() {
    this.setState({
      ...this.state,
      menuVisible: Store.getMenuState(),
    });
  }

  render() {
    const { sidebarNavItems } = this.state;

    const classes = classNames("main-sidebar", "px-0", "col-12", this.state.menuVisible && "open");

    return (
      <Col tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
        <SidebarMainNavbar hideLogoText={this.props.hideLogoText} />
        <SidebarSearch />
        <SidebarNavItems sidebarNavItems={sidebarNavItems} />
      </Col>
    );
  }
}

const NavItemComponent = (props) => {
  const { label, path } = props;
  const nodeClasses = ["tree-node"];

  return (
    <div className={nodeClasses.join(" ")}>
      <Link to={path} className="trnd-link">
        {label}
      </Link>
    </div>
  );
};

MainSidebar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

MainSidebar.defaultProps = {
  hideLogoText: false,
};

export default MainSidebar;
